var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioHifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.33333C4 7.14924 4.14924 7 4.33333 7C4.51743 7 4.66667 7.14924 4.66667 7.33333V10.6667C4.66667 10.8508 4.51743 11 4.33333 11C4.14924 11 4 10.8508 4 10.6667V7.33333ZM11.5 7.33333C11.5 7.14924 11.6492 7 11.8333 7C12.0174 7 12.1667 7.14924 12.1667 7.33333V10.6667C12.1667 10.8508 12.0174 11 11.8333 11C11.6492 11 11.5 10.8508 11.5 10.6667V7.33333ZM5.83333 5.83333C5.83333 5.64924 5.98257 5.5 6.16667 5.5C6.35076 5.5 6.5 5.64924 6.5 5.83333V12C6.5 12.1841 6.35076 12.3333 6.16667 12.3333C5.98257 12.3333 5.83333 12.1841 5.83333 12V5.83333ZM9.66667 6C9.66667 5.8159 9.81591 5.66667 10 5.66667C10.1841 5.66667 10.3333 5.81591 10.3333 6V12C10.3333 12.1841 10.1841 12.3333 10 12.3333C9.81591 12.3333 9.66667 12.1841 9.66667 12V6ZM13.3333 6C13.3333 5.81591 13.4826 5.66667 13.6667 5.66667C13.8508 5.66667 14 5.81591 14 6V12C14 12.1841 13.8508 12.3333 13.6667 12.3333C13.4826 12.3333 13.3333 12.1841 13.3333 12V6ZM7.66667 4.33333C7.66667 4.14924 7.8159 4 8 4C8.18409 4 8.33333 4.14924 8.33333 4.33333V13.6667C8.33333 13.8508 8.18409 14 8 14C7.8159 14 7.66667 13.8508 7.66667 13.6667V4.33333Z",
    fill: "#7100FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.5,
    stroke: "#110017"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioHifi);
export default __webpack_public_path__ + "static/media/audio_hifi.7557d0a11f9be56bf1290ca8eb43a845.svg";
export { ForwardRef as ReactComponent };